import React from 'react';
import {useSelector} from 'react-redux';
import type {EntraIdAuthRootState} from '../../../reducers/entraIdAuth';
import CountdownTimer from '../CountdownTimer';

interface EntraIdCountdownInfoProps {
    className?: string;
    compact?: boolean;
}

const EntraIdCountdownInfo = ({className, compact = false}: EntraIdCountdownInfoProps): JSX.Element => {
    const expiresAt = useSelector((state: EntraIdAuthRootState) => state.entraIdSession?.accessTokenExpiresAt);
    const description = 'Vypršení aktuálního přístupového tokenu Entra ID (ne konec přihlášení)';

    return (
        <div title={description} aria-label={description}>
            {expiresAt !== undefined && Number.isFinite(expiresAt)
                ? <CountdownTimer expireTime={new Date(expiresAt)} className={className}/>
                : <span className={className}>{compact ? 'Není známa' : 'Entra ID: platnost tokenu není známa'}</span>}
        </div>
    );
};

export default EntraIdCountdownInfo;
